var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyNobg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04214 2.8846C9.07336 1.28616 10.3789 0 11.9848 0C13.582 0 14.8821 1.27232 14.9268 2.85875C15.9081 3.38128 16.5761 4.41457 16.5761 5.60389L7.44037 5.60389C7.44037 4.43388 8.08687 3.41487 9.04214 2.8846ZM13.3268 2.75482C13.3268 3.49604 12.7259 4.09692 11.9847 4.09692C11.2434 4.09692 10.6426 3.49604 10.6426 2.75482C10.6426 2.01359 11.2434 1.41271 11.9847 1.41271C12.7259 1.41271 13.3268 2.01359 13.3268 2.75482ZM17.3767 3.06085V5.60379L21.4263 5.60378V31.457L2.54308 31.457V5.60379L6.59281 5.60378L6.59281 3.06085L0 3.06085V5.60379H0.000141894V31.457H0V33.9999H0.000141894V34H2.54308V33.9999L21.4263 33.9999V34H23.9693V33.9999H23.9696V31.457H23.9693V5.60378H23.9695V3.06085L17.3767 3.06085Z",
    fill: "#738395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyNobg);
export default __webpack_public_path__ + "static/media/copy-nobg.148f47c8c2dae7bf0207fb9ccb75a29d.svg";
export { ForwardRef as ReactComponent };